import React from 'react';
import { formatFileSize, formatDateTimeStrByTimestamp } from '@gp/utils/common';
import { DEFAULT_TIPS } from '@gp/components/CoverUploader/constants';

import type { IBaseProps } from '@home/types/common';
import type { ICover } from '@gp/components/CoverUploader/types';

import './index.scss';

interface ICoverInfoProps extends IBaseProps {
  tips?: string | React.ReactElement;
  data?: Pick<ICover, 'file_size' | 'timestamp'>;
}

const CoverInfo: React.FC<ICoverInfoProps> = (props) => {
  const { tips = DEFAULT_TIPS, data } = props;
  const { file_size: fileSize, timestamp } = data || {};

  return (
    <>
      <div className="dbg-game-overview-message-row">
        <span className="dbg-game-overview-message-label">File size</span>
        <span className="dbg-game-overview-message-text">{formatFileSize(fileSize)}</span>
      </div>
      <div className="dbg-game-overview-message-row">
        <span className="dbg-game-overview-message-label">Upload Day</span>
        <span className="dbg-game-overview-message-text">{formatDateTimeStrByTimestamp(timestamp)}</span>
      </div>
      {!!tips && (
        <div className="dbg-game-overview-message-row">
          <span className="dbg-game-overview-message-label">{tips}</span>
        </div>
      )}
    </>
  );
};

export default CoverInfo;
